import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Penalties\"}}\n\n<Penalties @event={{this.model}}/>",{ moduleName: "bullitttime-event/templates/event/timing/penalty.hbs" })